import { KYMW0909Component } from './kymw0909.component';

/**
 * 予約商品設定画面の値を管理するクラス
 *
 * @export KYMW0909Model
 * @class KYMW0909Model
 */
export class KYMW0909Model {
  kymw0909Component: KYMW0909Component;

  // 編集有無フラグ
  public isEdited = false;

  // モード
  public mode: number = null;

  // 遷移元から受け取る会員タブのアイテムコードリスト
  public coopInfoItemCoopCode = [];

  // アイテムコード
  public selectedItemCode = '';

  // アイテムコードリスト
  public itemCodeList = [];

  // 注文コード割当コード
  public pointExchangeOrderNumQuotaCode = '';

  // 注文コード割当リスト
  public pointExchangeOrderNumQuotaCodeList = [];

  // ポイント交換注文コード
  public pointExchangeOrderNum = '';

  // 専用商品名
  public pointExchangeGoodsName = '';

  // 専用商品名(カナ)
  public pointExchangeGoodsNameKana = '';

  // 専用規格名
  public pointExchangeGuideName = '';

  // 専用規格名(カナ)
  public pointExchangeGuideNameKana = '';

  // ポイント不足エラー区分
  public shortOfPointDiv = '';

  // ECのみフラグ
  public ecOnlyFlg: boolean = <boolean>false;

  // 消費税率
  public consumeTaxRate: number = <number>0;

  // 消費税区分
  public consumeTaxDiv: string = <string>'';
  
  // ポイント購入時割引率一括設定値
  public pointRateAllSetting: string = <string>'';

  // 会員生協別ポイント一覧
  public coopPointRateList: Array<any> = new Array<any>();

  // 追加フラグ
  public registFlg = '0';

  // 削除フラグ
  public deleteFlg = '0';

  // 会員生協別ポイント率一覧 ヘッダーチェックボックス
  public planGoodsCoopPointRateEnableFlgAll: boolean = <boolean>false;

  // 変更前のアイテムコード
  public beforeSelectedItemCode = '';

  // 初期表示にリセットするためのパラメータ
  public firstPointExchangeOrderNumQuotaCode = '';
  public firstPointExchangeOrderNum = '';
  public firstPointExchangeGoodsName = '';
  public firstPointExchangeGoodsNameKana = '';
  public firstPointExchangeGuideName = '';
  public firstPointExchangeGuideNameKana = '';
  public firstShortOfPointDiv = '';
  public firstEcOnlyFlg = false;
  public firstPointRateAllSetting = '';
  public firstCoopPointRateList = new Array<any>();

  // 登録済みのデータリスト
  public settedItemCodeList = [];

  // 会員生協別ポイント一覧（現状で登録されているデータ）
  public coopPointRateCurrentList: Array<any> = new Array<any>();
}
